import styled from '@emotion/styled';
import { Button } from '@silvertours/front-shared';
import { MenuIcon } from '../Header.styles';

const MenuButton = styled(Button)`
  padding: 0;
  background: none;

  :hover {
    background: none;
  }
`;

const StyledMenuIcon = styled(MenuIcon)`
  width: 1.5rem;
  height: 1.5rem;
`;

const List = styled.ul`
  display: flex;
  flex-direction: column;
  row-gap: ${({ theme }) => theme.spacing[50]};
`;
export { List, MenuButton, StyledMenuIcon };
